import { render, staticRenderFns } from "./select_plan.vue?vue&type=template&id=1d20d767&scoped=true&"
import script from "./select_plan.vue?vue&type=script&lang=js&"
export * from "./select_plan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d20d767",
  null
  
)

export default component.exports